import { render, staticRenderFns } from "./layout-default.vue?vue&type=template&id=edc1dda6&scoped=true"
import script from "./layout-default.vue?vue&type=script&lang=js"
export * from "./layout-default.vue?vue&type=script&lang=js"
import style0 from "./layout-default.vue?vue&type=style&index=0&id=edc1dda6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc1dda6",
  null
  
)

export default component.exports